export default __webpack_public_path__ + "static/media/cat16.21207318.gif";